import * as React from 'react';
import { Link } from 'react-router-dom';

import '../../node_modules/react-bootstrap-typeahead/css/Typeahead.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import { validateForm, onChange } from '../utils';
import CONSTANT from '../constant'
class Behaviour extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        const behaviour = props.behaviour;
        this.state = {
            name: { value: behaviour ? behaviour.name : '', name: 'name', error: '', isRequired: true },
            competencies: { value: behaviour ? behaviour.competencies : [], name: 'competencies', error: '', isRequired: true, options: [], show: true },
            status: { value: behaviour ? behaviour.status : '', name: 'status', error: '', isRequired: true },
            remark: { value: behaviour ? behaviour.remark : '', name: 'remark', error: '', isRequired: true },
            statusList: { value: behaviour ? behaviour.statusList : '', name: 'statusList', error: '', options: [{ code: 1, name: 'Active' }, { code: 2, name: 'Inactive' }], isRequired: true },
            code: { name: 'code', value: behaviour ? behaviour.code : '' }
        }
    }

    public render() {
        const { name, competencies, status, statusList, remark } = this.state;
        return (
            <React.Fragment>

                <div className="card mt-2">
                    <div className="card-header">
                        <b>Behaviour Skills</b>
                    </div>
                    <div className="card-body">
                        <form onSubmit={this._onSubmit}>
                            <div className="col-lg-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 form-group">
                                        <label>name / Level </label>
                                        <input
                                            name={name.name}
                                            onChange={this._onChange}
                                            value={name.value}
                                            type="text"
                                            className={name.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder="Enter name/level" 
                                            disabled={this.props.behaviour ? true : false}
                                            
                                            />
                                    </div>
                                    <div className="col-lg-4 form-group">
                                        <label>Competencies </label>

                                        <Typeahead
                                            allowNew={true}
                                            multiple={true}
                                            id="ta-course_name"
                                            placeholder="Select Competencies"
                                            name={competencies.name}
                                            minLength={0}
                                            options={competencies.options}
                                            onChange={(e: any) => this._typeaheadOnChange(competencies.name, e)}
                                            selected={competencies.value}
                                            labelKey="name"
                                            isInvalid={competencies.error.length > 0}
                                        />

                                    </div>
                                    <div className="col-lg-4 form-group">
                                        <label>Status</label>
                                        {this.renderStatus(status, statusList)}
                                    </div>
                                    <div className="col-lg-4 form-group">
                                        <label>Remark</label>
                                        <input
                                            name={remark.name}
                                            onChange={this._onChange}
                                            value={remark.value}
                                            type="text"
                                            className={remark.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder="Enter remark" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 ">
                                <button onClick={this._onSubmit} className="col-lg-2 btn button-full pull-right">Submit</button>
                                <Link to={CONSTANT.url.behaviourList} className="col-lg-2 btn btn-secondary mr-3 pull-right">Cancel</Link>
                            </div>
                        </form>
                    </div>
                </div>

            </React.Fragment>

        )
    }

    private _typeaheadOnChange(name: string, e: any) {
        let value = e;
        if (e.length > 0 && e[0].customOption) {
            value = [{ name: e[0].name }];
        }
        onChange(this, name, value);
    }

    private _onChange = (e: any, callback?: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    private renderStatus = (status: any, statusList: any) => {
        return (<select name={status.name} value={status.value}
            onChange={this._onChange} className={status.error.length > 0 ? "form-control is-invalid" : "form-control"}>
            <React.Fragment>
                <option>--Select--</option>
                {statusList.options.map((e: any, dIndex: number) => {
                    return e && (<option key={dIndex} value={e.status}>{e.name}</option>)
                })}
            </React.Fragment>
        </select>)
    }
    private _onSubmit = (e: any) => {
        e.preventDefault();
        const st = this.state;
        const model = {
            name: st.name.value,
            competencies: st.competencies.value,
            remark: st.remark.value,
            status: st.status.value,
            code: st.code.value,
        };
        this.props.onSubmit(model);

    }

}

export default Behaviour;